// Body.jsx – Professional Luxury Wellness Homepage (Enhanced)
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './body.css';
import { Link } from "react-router-dom"; 



import Slider from 'react-slick';

function Body() {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState({});

  // Testimonials data
  const testimonials = [
    {
      text: "Life-changing experience. I left feeling reborn, both physically and spiritually. The doctors truly understand holistic healing.",
      author: "Sarah Johnson",
      location: "United Kingdom",
      rating: 5
    },
    {
      text: "The most authentic Ayurveda I have ever experienced outside of India. Every detail, from herbs to therapies, was pure perfection.",
      author: "Michael Chen",
      location: "Singapore",
      rating: 5
    },
    {
      text: "A sanctuary of peace. After just one week, my chronic stress melted away. I've found my yearly retreat destination.",
      author: "Elizabeth Williams",
      location: "Australia",
      rating: 5
    },
    {
      text: "The Panchakarma program transformed my health. Professional staff, serene environment, and authentic traditions.",
      author: "David Thompson",
      location: "Canada",
      rating: 5
    },
    {
      text: "Exceptional care and genuine warmth. The therapists are highly skilled and deeply compassionate.",
      author: "Priya Sharma",
      location: "India",
      rating: 5
    },
    {
      text: "Words cannot describe the peace I found here. A true gem in Sri Lanka's wellness landscape.",
      author: "Maria Garcia",
      location: "Spain",
      rating: 5
    }
  ];

  // Auto testimonial rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            // Optional: track visibility state
            setIsVisible(prev => ({ ...prev, [entry.target.dataset.section]: true }));
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    const sections = document.querySelectorAll('.animate-section');
    sections.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Smooth scroll to section
  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);







   const [currentIndex, setCurrentIndex] = useState(0);
    const [expandedImage, setExpandedImage] = useState(null);
    const intervalRef = useRef(null);
  
    const images = [
      { src: "/president award.png", alt: "President Award Ayurveda" },
      { src: "/certi1.jpeg", alt: "" },
      { src: "/certi2.jpeg", alt: "" },
      { src: "/certi3.jpeg", alt: "" },
 

    ];
  
    // Always show 3 images (current, next, and previous)
    const visibleImages = [];
    for (let i = -1; i <= 1; i++) {
      const index = (currentIndex + i + images.length) % images.length;
      visibleImages.push(images[index]);
    }
  
    const moveNext = () => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    };
  
    const movePrev = () => {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };
  
    const handleImageClick = (image) => {
      setExpandedImage(image);
      clearInterval(intervalRef.current);
    };
  
    const closeExpandedImage = () => {
      setExpandedImage(null);
      intervalRef.current = setInterval(moveNext, 2000);
    };
  
    useEffect(() => {
      intervalRef.current = setInterval(moveNext, 2000);
      return () => clearInterval(intervalRef.current);
    }, []);
  
    const handleMouseEnter = () => clearInterval(intervalRef.current);
    const handleMouseLeave = () => {
      if (!expandedImage) {
        intervalRef.current = setInterval(moveNext, 2000);
      }
    };
  






  return (
    <main className="ew-body">

      {/* ==================== HERO ==================== */}
<section
  className="ew-hero"
  style={{
    backgroundImage: `url(${process.env.PUBLIC_URL}/footer%20banner.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
  }}
>
        <div className="ew-hero-overlay"></div>
        <div className="ew-hero-content animate-fade-in">
          <span className="hero-welcome">Welcome to Elysian Wellness</span>
          <h1 className="hero-title">
            Restore Your<br />Natural Balance
          </h1>
          <p className="hero-subtitle">
            Authentic Ayurvedic Healing in the Heart of Sri Lanka
          </p>
          <div className="hero-cta">
            <button 
              className="btn-primary" 
              onClick={() => navigate('/treatments')}
              aria-label="Explore our treatments"
            >
              Explore Treatments
            </button>
            <button 
              className="btn-outline" 
              onClick={() => navigate('/booking')}
              aria-label="Book your stay"
            >
              Book Your Stay
            </button>
          </div>
          <div className="hero-scroll-indicator" onClick={() => scrollToSection('signature-therapies')}>
            {/* <span>Discover More</span> */}
            <div className="scroll-arrow">↓</div>
          </div>
        </div>
      </section>

      {/* ==================== TRUST BADGES ==================== */}
      <div className="trust-badges">
        <div className="container">
          <div className="badges-grid">
            <div className="badge-item">
              <span className="badge-icon">🏆</span>
              <div>
                <strong>ISO Certified</strong>
                <small>Wellness Sanctuary</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon">🌿</span>
              <div>
                <strong>Organic Garden</strong>
                <small>Home-grown Herbs</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon">👥</span>
              <div>
                <strong>50+ Countries</strong>
                <small>Global Guests</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon">📅</span>
              <div>
                <strong>Since 2006</strong>
                <small>20+ Years Excellence</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== SIGNATURE THERAPIES ==================== */}
<section id="signature-therapies" className="animate-section banner-section">
  <div className="container">
    <div className="section-header">
      <span className="section-tag">Signature Experiences</span>
      <h2 className="section-title">Discover Our Healing Therapies</h2>
      <p className="section-subtitle">Time-honored treatments tailored to your unique constitution</p>
    </div>
    <div className="banners-grid">

      {/* Ayurvedic Full Body Massage 90min */}
      <div className="banner-card" onClick={() => navigate('/treatments?fullbody90')}>
        <img src="/fullbody90.jpg" alt="Ayurvedic Full Body Massage" loading="lazy" />
        <div className="banner-overlay">
          <span className="therapy-duration">90 Mins</span>
          <h3>Full Body Massage</h3>
          <p>Traditional Ayurvedic oil massage</p>
          <span className="banner-link">Learn More →</span>
        </div>
      </div>


      {/* Herbal Bath */}
      <div className="banner-card" onClick={() => navigate('/treatments?herbalbath')}>
        <img src="/hearbal bath.jpg" alt="Herbal Bath" loading="lazy" />
        <div className="banner-overlay">
          <span className="therapy-duration">30 Mins</span>
          <h3>Herbal Bath</h3>
          <p>Soothing herbal immersion</p>
          <span className="banner-link">Learn More →</span>
        </div>
      </div>

      {/* Shirodhara */}
      <div className="banner-card" onClick={() => navigate('/treatments?shirodhara')}>
        <img src="/shirodhara.jpg" alt="Shirodhara" loading="lazy" />
        <div className="banner-overlay">
          <span className="therapy-duration">45 Mins</span>
          <h3>Shirodhara</h3>
          <p>Oil flow for deep relaxation</p>
          <span className="banner-link">Learn More →</span>
        </div>
      </div>


    </div>
  </div>
</section>

      {/* ==================== WHO WE ARE ==================== */}
      <section className="animate-section who-we-are">
        <div className="container grid-2">
          <div className="content-text">
            <span className="tag">Since 2006</span>
            <h2>Your Sanctuary of Authentic Ayurveda</h2>
            <p className="lead-text">
              Nestled in the serene landscapes of Wellawaya, Sri Lanka, Elysians Wellness 
              Retreat brings together 5000-year-old Ayurvedic wisdom with modern luxury.
            </p>
            <p>
              Our mission is to help you return to your natural state of balance, vitality, 
              and inner peace through personalized healing programs.
            </p>
            <ul className="rich-bullets">
              <li>Certified Ayurvedic doctors & therapists</li>
              <li>Organic herbs grown in our own gardens</li>
              <li>Personalized programs based on your dosha</li>
              <li>ISO certified wellness sanctuary</li>
              <li>Guests from over 50 countries</li>
            </ul>
            <button className="btn-primary" onClick={() => navigate('/aboutus')}>
              Discover Our Story
            </button>
          </div>
          <div className="content-image">
            <img 
              src="/main hall.jpg" 
              alt="Elysians Wellness Retreat sanctuary with traditional Ayurvedic architecture" 
              loading="lazy"
            />
            <div className="image-caption">Our Main Healing Pavilion</div>
          </div>
        </div>
      </section>



{/* ==================== Certificate Section ==================== */}


<div className="monarch-hotel-container">
  <h1 className="monarch-hotel-heading">
    PRESIDENTIAL AYURVEDA EXCELLENCE AWARD – 2023
  </h1>

  <p className="monarch-hotel-para">
    We are proud recipients of the "ජනාධිපති වෛද්‍යව සූරී සම්මානය - 2023", 
    recognizing our outstanding contribution, commitment, and excellence in the field of Ayurveda healthcare.
  </p>


      <div 
        className="monarch-carousel-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="monarch-carousel">
          {visibleImages.map((image, i) => (
            <div 
              key={`${image.src}-${i}`}
              className={`carousel-item ${i === 1 ? 'center-item' : ''}`}
              onClick={() => handleImageClick(image)}
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
        <div className="carousel-controls">
          <button className="carousel-prev" onClick={movePrev}>&lt;</button>
          <button className="carousel-next" onClick={moveNext}>&gt;</button>
        </div>
      </div>

      {expandedImage && (
        <div className="image-modal" onClick={closeExpandedImage}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={closeExpandedImage}>&times;</button>
            <img 
              src={expandedImage.src} 
              alt={expandedImage.alt} 
              className="expanded-image"
            />
            <div className="image-caption">{expandedImage.alt}</div>
          </div>
        </div>
      )}
    </div>





      {/* ==================== WHY WE ARE SPECIAL ==================== */}
      <section className="animate-section why-special">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Difference</span>
            <h2 className="section-title">Why Guests Choose Elysian</h2>
          </div>
          <div className="why-grid">
            <div className="why-card">
              <div className="why-icon">🌱</div>
              <h3>100% Authentic</h3>
              <p>Traditional Ayurvedic protocols passed down through generations, preserved in their purest form</p>
            </div>
            <div className="why-card">
              <div className="why-icon">🌿</div>
              <h3>Organic & Pure</h3>
              <p>Herbs and oils sourced directly from our estate gardens, ensuring maximum potency</p>
            </div>
            <div className="why-card">
              <div className="why-icon">👨‍⚕️</div>
              <h3>Expert Care</h3>
              <p>Senior Ayurvedic physicians with 20+ years experience providing personalized attention</p>
            </div>
            {/* <div className="why-card">
              <div className="why-icon">🏔️</div>
              <h3>Serene Setting</h3>
              <p>Private villas surrounded by lush mountains and waterfalls for ultimate privacy</p>
            </div> */}
          </div>
        </div>
      </section>

      {/* ==================== HEALING JOURNEY ==================== */}
      <section className="animate-section journey-section">
        <div className="container">
          <div className="journey-content">
            <h2>Begin Your Healing Journey</h2>
            <p>Experience personalized wellness programs designed to restore balance and vitality</p>
            <div className="journey-steps">
              <div className="step">
                <span className="step-number">01</span>
                <h4>Consultation</h4>
                <p>Meet with our senior physician for dosha analysis</p>
              </div>
              <div className="step">
                <span className="step-number">02</span>
                <h4>Personalized Plan</h4>
                <p>Receive a tailored treatment program</p>
              </div>
              <div className="step">
                <span className="step-number">03</span>
                <h4>Healing Begins</h4>
                <p>Experience transformative therapies</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== TREATMENTS PREVIEW ==================== */}
     <section className="animate-section treatments-section">
  <div className="container">
    <div className="section-header">
      <span className="section-tag">Healing Arts</span>
      <h2 className="section-title">Our Therapeutic Treatments</h2>
    </div>
    <div className="treatments-grid">
      {/* Full Body Massage 90min */}
      <div className="treatment-card" onClick={() => navigate('/treatments?fullbody90')}>
        <img src="/fullbody90.jpg" alt="Ayurvedic Full Body Massage" loading="lazy" />
        <div className="treatment-info">
          <h3>Full Body Massage</h3>
          <p>90-minute traditional Ayurvedic massage</p>
          <span 
  
  style={{
    color: '#087343',
    fontWeight: '600',
    fontSize: '0.9rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    transition: 'gap 0.3s ease'
  }}
>
  View Details →
</span>
        </div>
      </div>
      
      
      
      {/* Head, Neck & Shoulder Massage */}
      <div className="treatment-card" onClick={() => navigate('/treatments?headneck')}>
        <img src="/headneckshoulder.webp" alt="Head Neck Shoulder Massage" loading="lazy" />
        <div className="treatment-info">
          <h3>Head, Neck & Shoulder</h3>
          <p>60-minute tension relief massage</p>
                    <span 
  
  style={{
    color: '#087343',
    fontWeight: '600',
    fontSize: '0.9rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    transition: 'gap 0.3s ease'
  }}
>
  View Details →
</span>
        </div>
      </div>
      
      
      
      {/* Foot Reflexology */}
      <div className="treatment-card" onClick={() => navigate('/treatments?reflexology')}>
        <img src="/foot massage.jpeg" alt="Foot Reflexology" loading="lazy" />
        <div className="treatment-info">
          <h3>Foot Reflexology</h3>
          <p>60-minute pressure point therapy</p>
                 <span 
  
  style={{
    color: '#087343',
    fontWeight: '600',
    fontSize: '0.9rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    transition: 'gap 0.3s ease'
  }}
>
  View Details →
</span>
        </div>
      </div>
      
    </div>
    <div className="section-footer">
      <button className="btn-outline" onClick={() => navigate('/treatments')}>
        View All Treatments
      </button>
    </div>
  </div>
</section>

      {/* ==================== TESTIMONIALS ==================== */}
      <section className="animate-section testimonials-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Guest Experiences</span>
            <h2 className="section-title">What Our Guests Say</h2>
          </div>
          <div className="testimonial-slider">
            <div 
              className="testimonial-track"
              style={{ transform: `translateX(-${currentTestimonial * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div className="testimonial-item" key={index}>
                  <div className="testimonial-content">
                    <div className="quote-mark">"</div>
                    <p>{testimonial.text}</p>
                    <div className="testimonial-rating">
                      {'★'.repeat(testimonial.rating)}
                    </div>
                    <div className="author-info">
                      <strong>{testimonial.author}</strong>
                      <span>{testimonial.location}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentTestimonial === index ? 'active' : ''}`}
                  onClick={() => setCurrentTestimonial(index)}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>













      {/* ==================== FINAL CTA ==================== */}
      <section className="final-cta">
        <div className="container">
          <h2>Ready to Transform Your Life?</h2>
          <p className="cta-text">Begin your journey to lasting wellness and inner peace today.</p>
          <button className="btn-primary-large" onClick={() => navigate('/booking')}>
            Reserve Your Place Now
          </button>
          <p className="cta-small">Limited availability for personalized programs</p>
        </div>
      </section>

    </main>
  );
}

export default Body;